import { FullViewportSpinnerWrapper, SpinnerAnimate, SpinnerCenteredInContainer } from './styles';

type SpinnerProps = {
  className?: string;
} & (
  | {
      centered?: boolean;
    }
  | {
      isFullViewportSpinner?: boolean;
    }
);

const Spinner = ({ className, ...props }: SpinnerProps) => {
  if ('isFullViewportSpinner' in props) {
    return (
      <FullViewportSpinnerWrapper>
        <SpinnerCenteredInContainer className={className} />
      </FullViewportSpinnerWrapper>
    );
  }

  if ('centered' in props) {
    return <SpinnerCenteredInContainer className={className} />;
  }

  return <SpinnerAnimate className={className} />;
};

export default Spinner;
